import { call, put, takeLatest } from 'redux-saga/effects'
import {
  CREATE_INVOICE,
  CREATE_INVOICE_SUCCESS,
  CREATE_INVOICE_FAILURE,
  CreateInvoiceActionType
} from 'src/redux/invoiceReducer'
import apiCall from 'src/helpers/apiCall'

function* createInvoiceSaga(action: CreateInvoiceActionType): Generator<any, void, any> {
  try {
    const response = yield call(apiCall, {
      method: 'POST',
      endpoint: '/dealers_api/invoices',
      api: 'market-api',
      params: {
        invoice: action.payload
      }
    })

    yield put(CREATE_INVOICE_SUCCESS({ pdf_url: response.pdf_url }))
  } catch (error: any) {
    yield put(CREATE_INVOICE_FAILURE())
  }
}

export default function* CreateInvoiceSaga(): Generator<any, void, any> {
  yield takeLatest(CREATE_INVOICE.type, createInvoiceSaga)
}
